<template>
<div>
  <v-card>
    <v-card-title>
      {{titulo}}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fas fa-search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="banks"
      :search="search"
      sort-by="nombre"
      class="elevation-1"
      :loading="loading"
      loading-text="Consultando datos... Espere por favor"
    >

      <template v-slot:[`item.hire_date`]="{ item }">
          {{ dateFormat(item.hire_date) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-icon v-if="item.status == 1" >fas fa-check</v-icon>
        <v-icon v-else >fas fa-times</v-icon>
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
         
          <v-dialog v-model="dialog" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn ref="boton2" color="primary" dark v-on="on">Nuevo Registro</v-btn>
            </template>
            <v-card>
              <v-card-title class="pt-0 pb-0">
                <span class="headline">{{ formTitle }}</span>
                <v-spacer></v-spacer>
               <v-radio-group
                 row
               >
                 <v-switch
                    v-model="editedItem.status"
                    inset
                    label="Activo"
                    class="mr-4"
                  ></v-switch>

               </v-radio-group>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- Poner mascara -->
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.rtn"
                          v-mask="'####-####-######'"
                          label="RTN"
                          :rules="editedItem.rtnRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nombres"
                          :rules="editedItem.nameRules"
                          autocomplete="new-name"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.position"
                          label="Posición"
                          :rules="editedItem.positionRules"
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.device_code"
                          label="Código en Dispositivo"
                          prepend-icon="mdi-fingerprint"
                          :rules="editedItem.deviceCodeRules"
                          maxlength="9"
                          counter="9"
                          required
                          oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 9)"
                        ></v-text-field>
                      </v-col>



                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.salary"
                          :rules="editedItem.salaryRules"
                          label="Salario"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.hire_date"
                              :rules="editedItem.dateRules"
                              label="Fecha de Contratación"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.hire_date"
                            no-title
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="450">
            <v-card>
              <v-card-title>
                <span>Desea eliminar a {{editedItem.name}}?</span>
                <v-spacer></v-spacer>
              </v-card-title>

              <v-card-actions>
                <v-btn color="green darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="red" text @click="eliminar">Aceptar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-icon color="success" small class="mr-2" @click="editItem(item)">fas fa-edit</v-icon>
        <v-icon color="red" small @click="deleteItem(item)">fas fa-trash-alt</v-icon>
      </template>
      
    </v-data-table>
  </v-card>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as moment from 'moment';
import axios from "axios";
export default {
  name: "employees",
  data: () => ({
    dialog: false,
    banks: [],
    menu: false,
    dialogDelete: false,
    search: "",
    loading: "",
    titulo: "Colaboradores",
    headers: [
      { text: "RTN", align: "left", value: "rtn" },
      { text: "Nombre", align: "left", value: "name" },
      { text: "Puesto", align: "left", value: "position" },
      { text: "Salario", align: "left", value: "salary" },
      { text: "Fecha de Contratación", align: "left", value: "hire_date" },
      { text: "#Dispositivo", align: "left", value: "device_code" },
      { text: "Activo", align: "left", value: "status" },
      { text: "Acciones", value: "action", sortable: false }
    ],
    editedIndex: -1,

    valid: true,
    editedItem: {
      id: "",
      rtn: "",
      name: "",
      salary: "",
      position: "",
      device_code: '',
      // hire_date: new Date().toISOString().substr(0, 10),
      dateRules: [v => !!v || "Escoge la fecha"],

      nameRules: [v => !!v || "Escribe el nombre"],
      positionRules: [v => !!v || "Escribe el puesto"],
      salaryRules: [v => !!v || "Escribe el salario diario"],
      rtnRules: [
                      v => !!v || "Escribe el RTN",
                      v => /^\d{4}-\d{4}-\d{5,6}$/.test(v) || "Escribe correctamente el RTN"
                ],
      deviceCodeRules: [
                          v => !!v || 'El código es obligatorio',
                          v => /^[0-9]+$/.test(v) || 'Solo se permiten números'
                       ],
      status: true
    },
    defaultItem: {
      id: "",
      rtn: "",
      name: "",
      salary: "",
      position: "",
      device_code: '',
      status: false,
      // hire_date: new Date().toISOString().substr(0, 10),
      dateRules: [v => !!v || "Escoge la fecha"],

      nameRules: [v => !!v || "Escribe el nombre"],
      positionRules: [v => !!v || "Escribe el puesto"],
      salaryRules: [v => !!v || "Escribe el salario diario"],
      rtnRules: [
                      v => !!v || "Escribe el RTN",
                      v => /^\d{4}-\d{4}-\d{5,6}$/.test(v) || "Escribe correctamente el RTN"
                ],
      deviceCodeRules: [
                          v => !!v || 'El código es obligatorio',
                          v => /^[0-9]+$/.test(v) || 'Solo se permiten números'
                       ],
      status: true
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    ...mapState(["db","headers_db"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    ...mapActions(["validateSession"]),
    // Metodos base de datos
    async getBanks(){
      await axios.get(this.db + 'payroll/employees',
        {
          headers: this.headers_db
        }).then(response => {
          this.banks = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.validateSession(error).then((resp) => { if(resp) this.getBanks(); })
        });
    },

    addProcess(payload){
      console.log(payload);
      axios.post(this.db + 'payroll/employee/add', payload,
      {
        headers: this.headers_db
      })
      .then((response) => {
        console.log(response);
        this.$store.dispatch("setSnackbar", {
          text: response.data.message,
        });
        this.banks.push(this.editedItem);
        this.getBanks();
        this.close();
      })
      .catch((error) => {
        console.log(error);
        this.validateSession(error).then((resp) => { if(resp) this.addProcess(payload); })
      });

    },
    updateProcess(payload){
      axios.post(this.db + 'payroll/employee/update', payload,
      {
        headers: this.headers_db
      })
      .then((response) => {
        console.log(response.data.message);
        this.$store.dispatch("setSnackbar", {
          text: response.data.message,
        });
        //this.getBanks();
      })
      .catch((error) => {
        console.log(error);
        this.validateSession(error).then((resp) => { if(resp) this.updateProcess(payload); })
      });

    },

    deleteProcess(id){

      axios.post(this.db + 'payroll/employee/delete', { id },
      {
        headers: this.headers_db
      })
      .then((response) => {
        console.log(response);
        this.banks = this.banks.filter(doc => {
        return doc.id != id
        })
      })
      .catch((error) => {
        console.log(error);
        this.validateSession(error).then((resp) => { if(resp) this.deleteProcess(id); })
      });

    },
    // FIN Metodos base de datos


    // Metodos Generales

    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    async editItem(item) {
      
      item.status = item.status == 1 ? true : false;
      this.editedIndex = this.banks.indexOf(item);
      this.dialog = true;
      this.editedItem = Object.assign({}, item);
    },

    deleteItem(item) {
      console.log(item.id);

      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    close() {
      this.dialog = false;
      this.dialogDelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
          this.editedItem.status = this.editedItem.status ? 1 : 0;

        if (this.editedIndex > -1) {
          Object.assign(this.banks[this.editedIndex], this.editedItem);
          console.log("editar",this.editedItem);
          this.updateProcess(this.editedItem);
          this.close();
        } else {
          this.addProcess(this.editedItem);
        }
        
      }
    },

    eliminar() {
      this.deleteProcess(this.editedItem.id);
      this.close();
    },
  },
  created() {
    this.getBanks();
  }
};
</script>

